module.exports = __webpack_public_path__ + "static/media/icon-copy.83418d24.svg";